import React, { useEffect, useState } from "react";

const styles = {
  body: {
    fontFamily: "Arial, sans-serif",
    background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
    color: "white",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    margin: 0,
    padding: 0,
  },
  container: {
    textAlign: "center",
    zIndex: 10,
    padding: "20px",
    maxWidth: "800px",
    animation: "fadeIn 1.5s ease-in",
  },
  greeting: {
    fontSize: "3rem",
    marginBottom: "20px",
    color: "#FFD700",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
    animation: "slideDown 1s ease-out",
  },
  year: {
    fontSize: "8rem",
    fontWeight: "bold",
    background: "linear-gradient(45deg, #FFD700, #FFA500, #FFD700)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    margin: "20px 0",
    animation: "glow 2s ease-in-out infinite alternate",
  },
  message: {
    fontSize: "1.3rem",
    lineHeight: 1.8,
    margin: "30px auto",
    color: "#E0E0E0",
    maxWidth: "600px",
    animation: "slideUp 1.5s ease-out",
  },
  wishesList: {
    margin: "40px auto",
    textAlign: "left",
    maxWidth: "500px",
    fontSize: "1.1rem",
    lineHeight: 2,
    listStyle: "none",
    padding: 0,
  },
  wishItem: {
    margin: "15px 0",
    paddingLeft: "30px",
    position: "relative",
    opacity: 0,
    transform: "translateX(-50px)",
  },
  wishItemAnimated: {
    animation: "slideRight 1s ease-out forwards",
  },
  ctaButton: {
    display: "inline-block",
    marginTop: "30px",
    padding: "15px 40px",
    background: "linear-gradient(45deg, #FFD700, #FFA500)",
    color: "#000",
    textDecoration: "none",
    borderRadius: "50px",
    fontSize: "1.2rem",
    fontWeight: "bold",
    boxShadow: "0 5px 15px rgba(255, 215, 0, 0.4)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    border: "none",
    animation: "bounce 2s infinite",
  },
  sparkle: {
    position: "absolute",
    width: "3px",
    height: "3px",
    background: "white",
    borderRadius: "50%",
    pointerEvents: "none",
  },
  firework: {
    position: "absolute",
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    pointerEvents: "none",
  },
};

const keyframes = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideDown {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideRight {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes glow {
    from { filter: drop-shadow(0 0 20px #FFD700) drop-shadow(0 0 30px #FFA500); }
    to { filter: drop-shadow(0 0 30px #FFD700) drop-shadow(0 0 40px #FF8C00); }
  }

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  @keyframes twinkle {
    0%, 100% { opacity: 0; }
    50% { opacity: 1; }
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
  }

  @media (max-width: 768px) {
    .year-text { font-size: 5rem !important; }
    .greeting-text { font-size: 2rem !important; }
    .message-text { font-size: 1.1rem !important; }
    .wishes-list { font-size: 1rem !important; }
  }
`;

export default function NewYearWish() {
  const [sparkles, setSparkles] = useState([]);
  const [fireworks, setFireworks] = useState([]);
  const [buttonHover, setButtonHover] = useState(false);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = keyframes;
    document.head.appendChild(styleSheet);

    const newSparkles = [];
    for (let i = 0; i < 50; i++) {
      newSparkles.push({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 2,
      });
    }
    setSparkles(newSparkles);

    const fireworkInterval = setInterval(() => {
      createFireworks();
    }, 5000);

    setTimeout(() => createFireworks(), 1000);

    return () => {
      clearInterval(fireworkInterval);
      document.head.removeChild(styleSheet);
    };
  }, []);

  const createFireworks = () => {
    const colors = [
      "#FFD700",
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#FFA07A",
      "#98D8C8",
      "#F7DC6F",
    ];

    for (let i = 0; i < 5; i++) {
      setTimeout(() => {
        const x = Math.random() * window.innerWidth;
        const y = Math.random() * window.innerHeight * 0.7;

        const newFireworks = [];
        for (let j = 0; j < 30; j++) {
          const angle = (Math.PI * 2 * j) / 30;
          const velocity = 100 + Math.random() * 100;

          newFireworks.push({
            id: Date.now() + j + i * 100,
            x: x,
            y: y,
            color: colors[Math.floor(Math.random() * colors.length)],
            vx: Math.cos(angle) * velocity,
            vy: Math.sin(angle) * velocity,
          });
        }

        setFireworks((prev) => [...prev, ...newFireworks]);

        setTimeout(() => {
          setFireworks((prev) =>
            prev.filter((fw) => !newFireworks.find((nf) => nf.id === fw.id))
          );
        }, 1000);
      }, i * 300);
    }
  };

  const wishes = [
    "May success follow you in everything you do",
    "May your dreams turn into reality",
    "May happiness surround you always",
    "May health and prosperity be yours",
    "May this year be your best one yet",
  ];

  return (
    <div style={styles.body}>
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          style={{
            ...styles.sparkle,
            left: `${sparkle.left}%`,
            top: `${sparkle.top}%`,
            animation: `twinkle 1.5s infinite ${sparkle.delay}s`,
          }}
        />
      ))}

      {fireworks.map((fw) => (
        <div
          key={fw.id}
          style={{
            ...styles.firework,
            left: fw.x,
            top: fw.y,
            background: fw.color,
            animation: `explode-${fw.id} 1s ease-out forwards`,
          }}
        >
          <style>{`
            @keyframes explode-${fw.id} {
              0% {
                transform: translate(0, 0);
                opacity: 1;
              }
              100% {
                transform: translate(${fw.vx}px, ${fw.vy}px);
                opacity: 0;
              }
            }
          `}</style>
        </div>
      ))}

      <div style={styles.container}>
        <h1 className="greeting-text" style={styles.greeting}>
          BharatAbroad Wishes Everyone a Happy New Year!
        </h1>
        <div className="year-text" style={styles.year}>
          2026
        </div>
        <p className="message-text" style={styles.message}>
          As we step into a new year filled with endless possibilities, may
          every moment bring you joy, success, and prosperity. Here's to new
          beginnings, cherished memories, and dreams coming true!
        </p>

        <ul style={styles.wishesList} className="wishes-list">
          {wishes.map((wish, index) => (
            <li
              key={index}
              style={{
                ...styles.wishItem,
                ...styles.wishItemAnimated,
                animationDelay: `${0.2 * (index + 1)}s`,
              }}
            >
              <span
                style={{
                  position: "absolute",
                  left: 0,
                  animation: "pulse 1.5s infinite",
                }}
              >
                ✨
              </span>
              {wish}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
